module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-5.24ad64a8.svg";